/**
 * @since 7.1.0
 */
export var AttendeeRole;
(function (AttendeeRole) {
    /**
     * @platform Android, iOS
     * @since 7.1.0
     */
    AttendeeRole["UNKNOWN"] = "unknown";
    /**
     * @platform iOS
     * @since 7.1.0
     */
    AttendeeRole["REQUIRED"] = "required";
    /**
     * @platform iOS
     * @since 7.1.0
     */
    AttendeeRole["OPTIONAL"] = "optional";
    /**
     * @platform iOS
     * @since 7.1.0
     */
    AttendeeRole["CHAIR"] = "chair";
    /**
     * @platform Android, iOS
     * @since 7.1.0
     */
    AttendeeRole["NON_PARTICIPANT"] = "nonParticipant";
    /**
     * @platform Android
     * @since 7.1.0
     */
    AttendeeRole["ATTENDEE"] = "attendee";
    /**
     * @platform Android
     * @since 7.1.0
     */
    AttendeeRole["ORGANIZER"] = "organizer";
    /**
     * @platform Android
     * @since 7.1.0
     */
    AttendeeRole["PERFORMER"] = "performer";
    /**
     * @platform Android
     * @since 7.1.0
     */
    AttendeeRole["SPEAKER"] = "speaker";
})(AttendeeRole || (AttendeeRole = {}));
//# sourceMappingURL=attendee-role.js.map